import { BaseService, Service } from "/@/cool";
@Service("withdraw")
class Withdraw extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["total"] = prefix + "total";
		this.permission["withdraw"] = prefix + "withdraw";
	}
	// 统计
	total(data: any) {
		return this.request({
			url: "/total",
			method: "POST",
			data
		});
	}
	// 提现
	withdraw(data: any) {
		return this.request({
			url: "/withdraw",
			method: "POST",
			data
		});
	}
}
export default Withdraw;
